import Account from "./Account/index.tsx";
import AccountUpdateCard from "./AccountUpdateCard.tsx";
import Achievements from "./Achievements.tsx";
import AdvancedPlayerSearch from "./AdvancedPlayerSearch.tsx";
import AllStar from "./AllStar.tsx";
import AllStarDunk from "./AllStarDunk.tsx";
import AllStarHistory from "./AllStarHistory.tsx";
import AllStarTeams from "./AllStarTeams/index.tsx";
import AllStarThree from "./AllStarThree.tsx";
import AutoExpand from "./AutoExpand.tsx";
import AutoRelocate from "./AutoRelocate.tsx";
import AwardRaces from "./AwardRaces.tsx";
import AwardsRecords from "./AwardsRecords.tsx";
import Colleges from "./Colleges.tsx";
import ComparePlayers from "./ComparePlayers/index.tsx";
import Countries from "./Countries.tsx";
import CustomizePlayer from "./CustomizePlayer/index.tsx";
import DailySchedule from "./DailySchedule.tsx";
import DangerZone from "./DangerZone/index.tsx";
import Dashboard from "./Dashboard.tsx";
import DefaultNewLeagueSettings from "./DefaultNewLeagueSettings/index.tsx";
import DeleteOldData from "./DeleteOldData.tsx";
import Depth from "./Depth.tsx";
import Draft from "./Draft/index.tsx";
import DraftHistory from "./DraftHistory.tsx";
import DraftLottery from "./DraftLottery.tsx";
import DraftPicks from "./DraftPicks.tsx";
import DraftScouting from "./DraftScouting/index.tsx";
import DraftTeamHistory from "./DraftTeamHistory.tsx";
import Dropbox from "./Dropbox.tsx";
import EditAwards from "./EditAwards.tsx";
import Exhibition from "./Exhibition.tsx";
import ExhibitionGame from "./ExhibitionGame.tsx";
import ExpansionDraft from "./ExpansionDraft.tsx";
import ExportLeague from "./ExportLeague.tsx";
import ExportPlayers from "./ExportPlayers.tsx";
import ExportStats from "./ExportStats.tsx";
import FantasyDraft from "./FantasyDraft.tsx";
import FreeAgents from "./FreeAgents.tsx";
import Frivolities from "./Frivolities.tsx";
import FrivolitiesDraftClasses from "./FrivolitiesDraftClasses.tsx";
import FrivolitiesDraftPosition from "./FrivolitiesDraftPosition.tsx";
import FrivolitiesJerseyNumbers from "./FrivolitiesJerseyNumbers.tsx";
import FrivolitiesTeamSeasons from "./FrivolitiesTeamSeasons.tsx";
import FrivolitiesTrades from "./FrivolitiesTrades.tsx";
import GlobalSettings from "./GlobalSettings/index.tsx";
import GmHistory from "./GmHistory.tsx";
import GameLog from "./GameLog.tsx";
import GodMode from "./GodMode.tsx";
import HallOfFame from "./HallOfFame.tsx";
import HeadToHead from "./HeadToHead.tsx";
import HeadToHeadAll from "./HeadToHeadAll.tsx";
import History from "./History.tsx";
import HistoryAll from "./HistoryAll.tsx";
import ImportPlayers from "./ImportPlayers.tsx";
import ImportPlayersReal from "./ImportPlayersReal.tsx";
import Inbox from "./Inbox.tsx";
import Injuries from "./Injuries.tsx";
import Leaders from "./Leaders.tsx";
import LeadersProgressive from "./LeadersProgressive.tsx";
import LeadersYears from "./LeadersYears.tsx";
import LeagueDashboard from "./LeagueDashboard/index.tsx";
import LeagueFinances from "./LeagueFinances.tsx";
import LeagueStats from "./LeagueStats.tsx";
import LiveGame from "./LiveGame.tsx";
import LoginOrRegister from "./LoginOrRegister/index.tsx";
import LostPassword from "./LostPassword.tsx";
import ManageConfs from "./ManageConfs.tsx";
import ManageTeams from "./ManageTeams/index.tsx";
import Message from "./Message/index.tsx";
import Most from "./Most/index.tsx";
import MultiTeamMode from "./MultiTeamMode.tsx";
import Negotiation from "./Negotiation.tsx";
import NegotiationList from "./NegotiationList.tsx";
import NewLeague from "./NewLeague/index.tsx";
import NewTeam from "./NewTeam.tsx";
import News from "./News.tsx";
import Notes from "./Notes.tsx";
import Player from "./Player/index.tsx";
import PlayerBios from "./PlayerBios.tsx";
import PlayerFeats from "./PlayerFeats.tsx";
import PlayerGameLog from "./PlayerGameLog.tsx";
import PlayerRatingDists from "./PlayerRatingDists.tsx";
import PlayerRatings from "./PlayerRatings.tsx";
import PlayerStatDists from "./PlayerStatDists.tsx";
import PlayerGraphs from "./PlayerGraphs/index.tsx";
import PlayerStats from "./PlayerStats.tsx";
import Playoffs from "./Playoffs.tsx";
import PowerRankings from "./PowerRankings.tsx";
import ProtectPlayers from "./ProtectPlayers.tsx";
import Relatives from "./Relatives.tsx";
import ResetPassword from "./ResetPassword.tsx";
import Roster from "./Roster/index.tsx";
import RosterContinuity from "./RosterContinuity.tsx";
import SavedTrades from "./SavedTrades.tsx";
import Schedule from "./Schedule.tsx";
import ScheduleEditor from "./ScheduleEditor/index.tsx";
import ScheduledEvents from "./ScheduledEvents.tsx";
import SeasonPreview from "./SeasonPreview.tsx";
import Settings from "./Settings/index.tsx";
import Standings from "./Standings.tsx";
import TeamFinances from "./TeamFinances.tsx";
import TeamGraphs from "./TeamGraphs/index.tsx";
import TeamHistory from "./TeamHistory/index.tsx";
import TeamRecords from "./TeamRecords.tsx";
import TeamStatDists from "./TeamStatDists.tsx";
import TeamStats from "./TeamStats.tsx";
import TragicDeaths from "./TragicDeaths.tsx";
import Trade from "./Trade/index.tsx";
import TradeProposals from "./TradeProposals.tsx";
import TradeSummary from "./TradeSummary/index.tsx";
import TradingBlock from "./TradingBlock/index.tsx";
import Transactions from "./Transactions.tsx";
import UpcomingFreeAgents from "./UpcomingFreeAgents.tsx";
import Upgrade65 from "./Upgrade65.tsx";
import WatchList from "./WatchList.tsx";

export default {
	Account,
	AccountUpdateCard,
	Achievements,
	AdvancedPlayerSearch,
	AllStar,
	AllStarDunk,
	AllStarHistory,
	AllStarTeams,
	AllStarThree,
	AutoExpand,
	AutoRelocate,
	AwardRaces,
	AwardsRecords,
	Colleges,
	ComparePlayers,
	Countries,
	CustomizePlayer,
	DailySchedule,
	DangerZone,
	Dashboard,
	DefaultNewLeagueSettings,
	DeleteOldData,
	Depth,
	Draft,
	DraftHistory,
	DraftLottery,
	DraftPicks,
	DraftScouting,
	DraftTeamHistory,
	Dropbox,
	EditAwards,
	Exhibition,
	ExhibitionGame,
	ExpansionDraft,
	ExportLeague,
	ExportPlayers,
	ExportStats,
	FantasyDraft,
	FreeAgents,
	Frivolities,
	FrivolitiesDraftClasses,
	FrivolitiesDraftPosition,
	FrivolitiesJerseyNumbers,
	FrivolitiesTeamSeasons,
	FrivolitiesTrades,
	GlobalSettings,
	GmHistory,
	GameLog,
	GodMode,
	HallOfFame,
	HeadToHead,
	HeadToHeadAll,
	History,
	HistoryAll,
	ImportPlayers,
	ImportPlayersReal,
	Inbox,
	Injuries,
	Leaders,
	LeadersProgressive,
	LeadersYears,
	LeagueDashboard,
	LeagueFinances,
	LeagueStats,
	LiveGame,
	LoginOrRegister,
	LostPassword,
	ManageConfs,
	ManageTeams,
	Message,
	Most,
	MultiTeamMode,
	Negotiation,
	NegotiationList,
	NewLeague,
	NewTeam,
	News,
	Notes,
	Player,
	PlayerBios,
	PlayerFeats,
	PlayerGameLog,
	PlayerRatingDists,
	PlayerRatings,
	PlayerStatDists,
	PlayerGraphs,
	PlayerStats,
	Playoffs,
	PowerRankings,
	ProtectPlayers,
	Relatives,
	ResetPassword,
	Roster,
	RosterContinuity,
	SavedTrades,
	Schedule,
	ScheduleEditor,
	ScheduledEvents,
	SeasonPreview,
	Settings,
	Standings,
	TeamFinances,
	TeamGraphs,
	TeamHistory,
	TeamRecords,
	TeamStatDists,
	TeamStats,
	Trade,
	TradeProposals,
	TradeSummary,
	TradingBlock,
	TragicDeaths,
	Transactions,
	UpcomingFreeAgents,
	Upgrade65,
	WatchList,
};
